import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonios } from '../data/testimonios';
import { compradores } from '../data/compras';
const recientes = compradores.slice(0, 5);
export function TestimonialsSection() {
  return <section className="w-full bg-cream-200 px-4 py-8 sm:px-8 sm:py-12" data-id="element-154" data-mp="1mzivt9l22tot">
      <div className="mx-auto max-w-6xl" data-id="element-155" data-mp="1r0ubama7tyja">
        {/* Gente que ya compró */}
        <div className="flex flex-col items-center gap-2.5 text-center sm:flex-row sm:justify-center sm:gap-4" data-id="element-156" data-mp="1d24e76nebyux">
          <span className="flex -space-x-2" aria-hidden="true" data-id="element-157" data-mp="1i17lkxqumh62">
            {recientes.map(persona => <span key={persona.nombre} className="flex h-7 w-7 items-center justify-center rounded-full border-2 border-cream-200 bg-ink-800 font-display text-xs font-bold text-cream" data-id="element-158" data-mp="1427wxq3c629w">
                {persona.nombre.charAt(0)}
              </span>)}
          </span>
          <p className="font-sans text-sm text-ink-700" data-id="element-159" data-mp="32g9alwpwd2hk">
            <strong className="font-bold text-ink-900" data-id="element-160" data-mp="2v12ppay0r1fx">
              +1.200 familias y docentes
            </strong>{' '}
            ya están usando el Mega Pack
          </p>
          <p className="flex items-center gap-1 font-sans text-sm font-semibold text-ink-900" aria-label="Valoración promedio: 4.9 sobre 5" data-id="element-161" data-mp="34re0nhg4eawb">
            <StarIcon className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-162" data-mp="2zuduz7n6na5q" />
            4.9 / 5
          </p>
        </div>

        {/* Testimonios compactos */}
        <ul className="mt-5 grid grid-cols-1 gap-2 sm:mt-6 sm:grid-cols-2 sm:gap-3 lg:grid-cols-3" data-id="element-163" data-mp="275zw6po9s9t4">
          {testimonios.map(testimonio => <li key={testimonio.nombre} className="flex h-full flex-col rounded-lg border border-cream-300 bg-white px-3 py-2.5" data-id="element-164" data-mp="2h0rtrthuqwnw">
              <p className="font-sans text-[13px] leading-snug text-ink-700" data-id="element-165" data-mp="3sh8cpwsm7vfi">
                “{testimonio.texto}”
              </p>
              <p className="mt-1.5 font-sans text-[11px] leading-tight text-ink-600" data-id="element-166" data-mp="3dqxyzqcmwrf">
                <strong className="font-bold text-ink-900" data-id="element-167" data-mp="8d2ec7mt008h">
                  {testimonio.nombre}
                </strong>{' '}
                · {testimonio.rol} · {testimonio.lugar}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}